import { RequestBuilder } from '../request_builder'

export class V2RequestBuilder extends RequestBuilder {
  constructor (serverUrl) {
    super(serverUrl)
    this.segment = 'v2'
  }

  users () {
    this.filters.push('users')
    return this
  }

  forType (type) {
    this.addQuery('type', type)
    return this
  }

  addFilter (filter) {
    this.addQuery(filter.filterName, filter.value)
  }
}



// WEBPACK FOOTER //
// ./src/js/builders/request_builder/modules/v2_request_builder.js